import { Badge } from '@nesso/ui/primitives/badge';

type Props = {
    isEmergencyContact: boolean;
    isBillingContact: boolean;
};

export function ContactRoleTags({ isEmergencyContact, isBillingContact }: Props) {
    if (!isEmergencyContact && !isBillingContact) return null;

    return (
        <div className="flex items-center gap-1 pb-0.5">
            {isEmergencyContact && <Badge variant="secondarySoft">Emergency</Badge>}
            {isBillingContact && <Badge variant="info">Billing</Badge>}
        </div>
    );
}
